import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { defineStore } from "pinia";

const moment = extendMoment(Moment);

export const useAnalyticsStore = defineStore('analytics', {
    state: () => ({
        fields: null,
        from: null,
        fromDefault: null,
        to: null,
        toDefault: null,
        companyCreatedAt: null,
        chartDataLimit: 30,
    }),
    getters: {
        getFrom(state) {
            return state.from;
        },
        getTo(state) {
            return state.to;
        },
        getCompanyCreatedAt(state) {
            return state.companyCreatedAt;
        },
        getDatesToFill(startDate, endDate, seriesFormat) {
            const dates = [];
            const dateRange = moment.range(startDate, endDate);
            for (const date of dateRange.by(seriesFormat)) {
                dates.push({ x: this.parseKey(date), y: 0 });
            }
            return dates;
        },
    },
    actions: {
        setFields(payload) {
            this.fields = payload;
        },
        setFrom(data) {
            if (!data && !!this.fromDefault) {
                this.from = this.fromDefault;
            } else {
                this.from = data;
            }
            if (!this.fromDefault) this.fromDefault = data;
        },
        setTo(data) {
            if (!data && !!this.toDefault) {
                this.to = this.toDefault;
            } else {
                this.to = data;
            }
            if (!this.toDefault) this.toDefault = data;
        },
        setCompanyCreatedAt(date) {
            this.companyCreatedAt = date;
        },
    },
});
